export default __webpack_public_path__ + "static/media/Cane2Sugar_02.12dbe560.png";